(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../modules/data/channels.js'),
            require('../enums/colors.js'),
            require('../enums/metrics.js'),
            require('../strings/strings.js'),
            require('../modules/utils/metric.js'),
            require('../modules/metric/metric.js'),
            require('../modules/utils/sort.js'),
            require('../modules/formatter.js'),
            require('lodash')
        );

    } else {
        RivalIQ.metrics.definitions.instagram = exportFn(
            RivalIQ.data.channels,
            RivalIQ.enums.colors,
            RivalIQ.enums,
            RivalIQ.strings,
            RivalIQ.utils.metric,
            RivalIQ.metric,
            RivalIQ.utils.sort,
            RivalIQ.formatter,
            window._
        );
    }

    function exportFn(channels, colors, metricEnums, strings, utils, metricFn, sort, formatter, _) {
        const channel = channels.get('instagram');

        const getValueByDimension = function (dimension, a, b) {
            return function (data, metric) {
                return (metricFn.hasDimension(metric, dimension) ? a : b);
            };
        };

        return {
            className: channel.get('channel'),
            format: channel.get('name'),
            name: channel.get('name'),
            color: colors.instagramHighContrast,
            engagement_total: {
                description: function (val, metric) {
                    if (metric.source === metricEnums.sources.INSTAGRAM_INSIGHTS) {
                        return strings.instagram_insights_post_engagement_total_description;
                    }
                    if (utils.useDetailsDescription(metric)) {
                        return strings.instagram_post_details_engagement_total_description;
                    }
                    if (metric.dataSource === 'discovery') {
                        return strings.discovery_instagram_posts_engagement_total_description;
                    }
                    return strings.instagram_posts_engagement_total_description;
                }
            },
            engagement_total_insights: {
                name: 'Engagement Total',
                description: strings.instagram_insights_engagement_total_insights_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            organic_engagement_total: {
                name: 'Engagement Total, Organic',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_engagement_total_description, strings.instagram_insights_organic_engagement_total_description),
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_engagement_total: {
                name: 'Engagement Total, Paid',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_engagement_total_description, strings.instagram_insights_paid_engagement_total_description),
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            engagement_total_per_post: {
                name: 'Engagement Total / Post',
                description: strings.instagram_engagement_total_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT
            },
            organic_engagement_total_per_post: {
                name: 'Engagement Total / Post, Organic',
                description: strings.instagram_insights_organic_engagement_total_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_engagement_total_per_post: {
                name: 'Engagement Total / Post, Paid',
                description: strings.instagram_insights_paid_engagement_total_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            engagement_total_per_post_insights: {
                name: 'Engagement Total / Post',
                description: strings.instagram_insights_engagement_total_per_post_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            engagement_rate: { // DEPRECATED
                description: function (val, metric) {
                    if (metric.source === metricEnums.sources.INSTAGRAM_INSIGHTS) {
                        return strings.instagram_insights_post_engagement_rate_description;
                    }

                    const useDetails = utils.useDetailsDescription(metric);
                    return useDetails ? strings.instagram_post_details_engagement_rate_description : strings.instagram_posts_engagement_rate_description;
                }
            },
            organic_engagement_rate: { // DEPRECATED
                name: 'Engagement Rate by Reach, Organic',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ENGAGEMENT,
                description: strings.instagram_insights_post_organic_engagement_rate_description
            },
            paid_engagement_rate: { // DEPRECATED
                name: 'Engagement Rate by Reach, Paid',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ENGAGEMENT,
                description: strings.instagram_insights_post_paid_engagement_rate_description
            },
            engagement_rate_by_impression: {
                name: 'Engagement Rate by Impression',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ENGAGEMENT,
                description: getValueByDimension('post', strings.instagram_insights_post_engagement_rate_by_impression_description, strings.instagram_insights_engagement_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            organic_engagement_rate_by_impression: {
                name: 'Engagement Rate by Impression, Organic',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ENGAGEMENT,
                description: getValueByDimension('post', strings.instagram_insights_post_organic_engagement_rate_by_impression_description, strings.instagram_insights_organic_engagement_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_engagement_rate_by_impression: {
                name: 'Engagement Rate by Impression, Paid',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ENGAGEMENT,
                description: getValueByDimension('post', strings.instagram_insights_post_paid_engagement_rate_by_impression_description, strings.instagram_insights_paid_engagement_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            engagement_rate_by_presence_reach: {
                name: 'Engagement Rate by Follower',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ENGAGEMENT,
                description: getValueByDimension('post', strings.instagram_insights_post_engagement_rate_by_presence_reach_description, strings.instagram_insights_engagement_rate_by_presence_reach_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            avg_engagement_rate_per_post: {
                description: strings.instagram_average_post_engagement_rate_description
            },
            avg_engagement_rate_per_post_insights: {
                name: 'Engagement Rate by Follower',
                description: strings.instagram_average_post_engagement_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            audience: {
                name: 'Followers',
                description: function (val, metric) {
                    if (metric.dataSource === 'discovery') {
                        return strings.discovery_instagram_followed_by_description;
                    }

                    if (metric.source === metricEnums.sources.INSTAGRAM_INSIGHTS) {
                        return strings.instagram_insights_post_presence_reach_description;
                    }
                    return strings.instagram_followed_by_description;
                },
                metricType: metricEnums.metricType.TOTAL,
                category: 'post_analysis',
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            presence_reach: {
                name: 'Followers',
                description: function (val, metric) {
                    if (metric.dataSource === 'discovery') {
                        return strings.discovery_instagram_followed_by_description;
                    }

                    if (metric.source === metricEnums.sources.INSTAGRAM_INSIGHTS) {
                        return strings.instagram_insights_post_presence_reach_description;
                    }
                    return strings.instagram_followed_by_description;
                },
                noHistoricData: true,
                collection: getValueByDimension('post', metricEnums.collection.GENERAL, metricEnums.collection.AUDIENCE)
            },
            potential_reach: {
                description: strings.instagram_potential_reach_description,
                noHistoricData: true
            },
            followers_to_following: {
                description: strings.instagram_followers_following_ratio_description,
                noHistoricData: true,
                summable: false
            },
            followers_to_following_insights: {
                name: 'Followers / Following Ratio',
                description: strings.instagram_followers_following_ratio_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.AUDIENCE,
                metricType: metricEnums.metricType.TOTAL,
                noHistoricData: true,
                summable: false
            },
            display_name: {
                name: 'Full Name',
                description: strings.instagram_full_name_description
            },
            display_name_size: {
                name: 'Full Name Length',
                description: strings.instagram_full_name_length_description
            },
            avg_count_per_day: {
                description: strings.instagram_average_daily_posts_description
            },
            avg_count_per_week: {
                description: strings.instagram_avg_count_per_week_description
            },
            avg_engagement_total_per_day: {
                description: strings.instagram_average_daily_posts_engagement_total_description
            },
            posts_per_day: {
                name: 'Posts / Day',
                description: strings.instagram_insights_posts_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                metricValueType: metricEnums.metricValueType.AVERAGE
            },
            posts_per_week: {
                name: 'Posts / Week',
                description: strings.instagram_insights_posts_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                metricValueType: metricEnums.metricValueType.AVERAGE
            },
            total_impressions_per_day: {
                name: 'Impressions / Day',
                description: strings.cross_channel_impressions_per_period_description,
                type: metricEnums.dataType.NUMERIC
            },
            organic_total_impressions_per_day: {
                name: 'Impressions / Day, Organic',
                description: strings.cross_channel_organic_impressions_per_period_description,
                type: metricEnums.dataType.NUMERIC
            },
            engagement_type: {
                // This defines the order these will appear in bar charts.
                dimensionValues: _.constant(['applause', 'conversation']),

                value: {
                    applause: {
                        format: utils.formatDimensionFn('Likes'),
                        className: 'x-instagram',
                        engagement_total: {
                            name: 'Likes',
                            description: function (val, metric) {
                                if (utils.useDetailsDescription(metric)) {
                                    return strings.instagram_post_details_likes_description;
                                }
                                if (metric.dataSource === 'discovery') {
                                    return strings.discovery_instagram_posts_likes_description;
                                }
                                return strings.instagram_posts_likes_description;
                            }
                        },
                        avg_engagement_total_per_day: {
                            name: 'Likes / Day',
                            description: strings.instagram_average_daily_posts_likes_description
                        }
                    },
                    conversation: {
                        format: utils.formatDimensionFn('Comments'),
                        className: 'x-instagram-secondary',
                        engagement_total: {
                            name: 'Comments',
                            description: function (val, metric) {
                                if (utils.useDetailsDescription(metric)) {
                                    return strings.instagram_post_details_comments_description;
                                }
                                if (metric.dataSource === 'discovery') {
                                    return strings.discovery_instagram_posts_comments_description;
                                }
                                return strings.instagram_posts_comments_description;
                            }
                        },
                        avg_engagement_total_per_day: {
                            name: 'Comments / Day',
                            description: strings.instagram_average_daily_posts_comments_description
                        }
                    }
                }
            },
            count: {
                name: function (val, metric) {
                    return (metricEnums.insightsObjectType && (metric.objectType === metricEnums.insightsObjectType.story)) ? 'Frames' : 'Posts';
                },
                description: function (val, metric) {
                    return (metricEnums.insightsObjectType && (metric.objectType === metricEnums.insightsObjectType.story)) ? strings.instagram_stories_description : strings.instagram_posts_description;
                }
            },
            following: {
                name: 'Following',
                description: strings.instagram_following_description,
                noHistoricData: true,
                summable: false
            },
            following_insights: {
                name: 'Following',
                description: strings.instagram_following_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.AUDIENCE,
                metricType: metricEnums.metricType.TOTAL,
                noHistoricData: true,
                summable: false
            },
            lifetime_count: {
                name: 'Posts, Lifetime',
                description: strings.instagram_lifetime_posts_description,
                collection: metricEnums.collection.ACTIVITY
            },
            lifetime_count_insights: {
                name: 'Posts, Lifetime',
                description: strings.instagram_lifetime_posts_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                metricType: metricEnums.metricType.TOTAL
            },
            overview: {
                description: strings.instagram_overview_description,
                missingDataFormat: function (data, metric) {
                    return (metric.isMainPeriod(data) && !_.includes(metric.dimensions, 'companySetId') ? '[ not on channel or not a business profile ]' : metricEnums.strings.MISSING);
                }
            },
            post_reach_per_day: {
                metricValueType: metricEnums.metricValueType.AVERAGE,
                name: 'Post Reach / Day',
                description: strings.instagram_insights_post_reach_per_day_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                summable: false
            },
            post_impressions: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Post Impressions',
                description: strings.instagram_insights_page_post_impressions_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS
            },
            organic_post_impressions: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Post Impressions, Organic',
                description: strings.instagram_insights_organic_post_impressions_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS
            },
            paid_post_impressions: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Post Impressions, Paid',
                description: strings.instagram_insights_paid_post_impressions_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS
            },
            new_follower_count: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Follower Adds',
                description: strings.instagram_insights_new_follower_count_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            follower_loss: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Follower Removes [DEPRECATED]',
                description: strings.instagram_insights_follower_loss_profile_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            followers_count: {
                metricType: metricEnums.metricType.TOTAL,
                name: 'Followers',
                description: strings.instagram_insights_followers_count_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            email_contacts: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Email Contacts Clicks',
                description: strings.instagram_insights_email_contacts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                enoughDataKey: 'statistics'
            },
            phone_call_clicks: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Phone Call Clicks',
                description: strings.instagram_insights_phone_call_clicks_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                enoughDataKey: 'statistics'
            },
            text_message_clicks: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Text Message Clicks',
                description: strings.instagram_insights_text_message_clicks_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                enoughDataKey: 'statistics'
            },
            get_directions_clicks: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Get Directions Clicks',
                description: strings.instagram_insights_get_directions_clicks_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                enoughDataKey: 'statistics'
            },
            website_clicks: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Website Clicks',
                description: strings.instagram_insights_website_clicks_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                enoughDataKey: 'statistics'
            },
            profile_views: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Profile Views',
                description: strings.instagram_insights_profile_views_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'statistics'
            },
            profile_engagements: {
                metricType: metricEnums.metricType.VOLUME,
                name: 'Profile Engagements',
                description: strings.instagram_insights_profile_engagements_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            story_max_reach: {
                name: 'Story Peak Reach',
                description: strings.instagram_insights_story_max_reach_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories'
            },
            story_max_reach_rate: {
                name: 'Story Peak Reach Rate by Follower',
                description: strings.instagram_insights_story_max_reach_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories'
            },
            story_max_reach_per_day: {
                name: 'Peak Reach / Story',
                description: strings.instagram_insights_peak_reach_per_story_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories',
                summable: false
            },
            total_num_stories: { // custom dashboards metric
                name: 'Frames',
                description: strings.instagram_insights_num_stories_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                enoughDataKey: 'stories'
            },
            story_replies: {
                name: 'Frame Replies',
                description: strings.instagram_insights_stories_replies_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                noHistoricData: true,
                enoughDataKey: 'stories'
            },
            replies_per_story: {
                name: 'Replies / Frame',
                description: strings.instagram_insights_stories_replies_per_story_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                noHistoricData: true,
                enoughDataKey: 'stories',
                summable: false
            },
            daily_posts: {
                name: 'Posts',
                description: strings.instagram_insights_daily_posts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY
            },
            organic_daily_posts: {
                name: 'Posts, Organic',
                description: strings.instagram_insights_organic_daily_posts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY
            },
            paid_daily_posts: {
                name: 'Posts, Promoted',
                description: strings.instagram_insights_paid_daily_posts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY
            },
            audience_gender_age: {
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                metricType: metricEnums.metricType.TOTAL,
                name: function (val, metric) {
                    const gender = metric.gender;
                    const title = strings.instagram_insights_audience_gender_age_name;
                    if (gender) {
                        const age = metric.age_range;
                        const names = utils.genderAgeNames(gender, age);

                        if (age) {
                            return [`${title}, `, names.gender, names.age].join(' ');
                        }

                        return `${title}, ${names.gender}`;
                    }

                    return title;
                },
                description: function (val, metric) {
                    let gender = metric.gender;
                    const age = metric.age_range;

                    if (gender === 'unspecified') {
                        gender = 'gender-unspecified person';
                    }

                    if (gender && age) {
                        return `The number of ${gender}s aged ${age} following this account on Instagram.`;
                    } else if (gender) {
                        return `The number of ${gender}s following this account on Instagram.`;
                    }

                    return strings.instagram_insights_audience_gender_age_description;
                },
                collection: metricEnums.collection.AUDIENCE,
                summable: false
            },
            gender: {
                audience_gender_age: {
                    collection: metricEnums.collection.AUDIENCE
                }
            },
            story_day_date: {
                name: 'Published Date',
                type: metricEnums.dataType.STRING,
                enoughDataKey: 'stories'
            },
            days_with_story: {
                name: 'Stories',
                description: strings.instagram_insights_days_with_story_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                enoughDataKey: 'stories'
            },
            stories_retention_rate: {
                name: 'Story Retention Rate by Reach',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                description: getValueByDimension('story', strings.instagram_insights_average_stories_retention_rate_description, strings.instagram_insights_storyday_stories_retention_rate_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            stories_per_day: {
                name: 'Frames / Story',
                type: metricEnums.dataType.NUMERIC,
                description: strings.instagram_insights_frames_per_story_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                enoughDataKey: 'stories',
                summable: false
            },
            max_reach: {
                name: 'Peak Reach',
                description: strings.instagram_insights_storyday_max_reach_description,
                metricType: metricEnums.metricType.TOTAL,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories'
            },
            max_reach_rate: {
                name: 'Story Peak Reach Rate by Follower',
                description: strings.instagram_insights_storyday_max_reach_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories',
                summable: false
            },
            num_stories: { // story tab metric
                name: 'Frames',
                description: strings.instagram_insights_storyday_num_stories_description,
                metricType: metricEnums.metricType.VOLUME,
                enoughDataKey: 'stories'
            },
            max_reach_per_day: {
                name: 'Peak Reach / Story',
                metricType: metricEnums.metricType.AVERAGE,
                description: strings.instagram_insights_max_reach_per_day_description,
                enoughDataKey: 'stories',
                summable: false
            },
            impressions_per_story: {
                name: 'Impressions / Frame',
                description: getValueByDimension('storyDay', strings.instagram_insights_storyday_impressions_per_frame_description, strings.instagram_insights_story_impressions_per_story_description),
                type: metricEnums.dataType.NUMERIC,
                metricType: metricEnums.metricType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'stories',
                summable: false
            },
            story_impressions_per_day: {
                name: 'Impressions / Story',
                description: strings.instagram_insights_story_impressions_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                enoughDataKey: 'stories',
                summable: false
            },
            story_impressions: {
                name: getValueByDimension('storyDay', 'Story Impressions', 'Frame Impressions'),
                description: getValueByDimension('storyDay', strings.instagram_insights_storyday_story_impressions_description, strings.instagram_insights_page_story_impressions_description),
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'stories'
            },
            average_completion_rate: {
                name: 'Completion Rate / Frame',
                description: strings.instagram_insights_average_completion_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricType: metricEnums.metricType.AVERAGE,
                enoughDataKey: 'stories'
            },
            completion_rate_per_story: {
                name: 'Frame Completion Rate by Impression',
                description: strings.instagram_insights_completion_rate_per_story_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricType: metricEnums.metricType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            completions: {
                name: 'Frame Completions',
                description: strings.instagram_insights_completions_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            completions_per_story: {
                name: 'Completions / Frame',
                description: strings.instagram_insights_completions_per_story_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories',
                summable: false
            },
            exits: {
                name: 'Exits',
                description: function (data, metric) {
                    if (metricFn.hasDimension(metric, 'storyDay')) {
                        return strings.instagram_insights_storyday_exits_description;
                    } else if (metricFn.hasDimension(metric, 'story')) {
                        return strings.instagram_insights_story_exits_description;
                    } else {
                        return strings.instagram_insights_exits_description;
                    }
                },
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            exits_per_story: {
                name: 'Exits / Frame',
                description: strings.instagram_insights_exits_per_story_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories',
                summable: false
            },
            exit_rate: {
                name: 'Exit Rate by Impression',
                description: strings.instagram_insights_story_exit_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            exit_rate_per_story: {
                name: 'Exit Rate by Impression',
                description: strings.instagram_insights_exit_rate_per_story_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories',
                summable: false
            },
            full_view_rate: {
                name: 'Full View Rate by Impression',
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                description: strings.instagram_insights_story_full_view_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                enoughDataKey: 'stories'
            },
            average_full_view_rate: {
                name: 'Full View Rate by Impression',
                description: strings.instagram_insights_average_full_view_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            impressions: {
                name: getValueByDimension('story', 'Frame Impressions', 'Impressions'),
                modalName: getValueByDimension('post', 'Total Impressions', 'Impressions'),
                collection: metricEnums.collection.IMPRESSIONS,
                description: function (data, metric) {
                    if (metricFn.hasDimension(metric, 'storyDay')) {
                        return strings.instagram_insights_storyday_story_impressions_description;
                    } else if (metricFn.hasDimension(metric, 'post') || metric.objectType === 'post') {
                        return strings.instagram_insights_post_impressions_description;
                    } else {
                        return strings.instagram_insights_story_impressions_description;
                    }
                },
                type: metricEnums.dataType.TOTAL
            },
            organic_impressions: {
                name: 'Impressions, Organic',
                collection: metricEnums.collection.IMPRESSIONS,
                description: strings.instagram_insights_post_organic_impressions_description
            },
            paid_impressions: {
                name: 'Impressions, Paid',
                collection: metricEnums.collection.IMPRESSIONS,
                description: strings.instagram_insights_post_paid_impressions_description
            },
            impressions_per_post: {
                name: 'Impressions / Post',
                description: strings.instagram_insights_impressions_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                summable: false
            },
            organic_impressions_per_post: {
                name: 'Impressions / Post, Organic',
                description: strings.instagram_insights_organic_impressions_per_post_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                summable: false
            },
            paid_impressions_per_post: {
                name: 'Impressions / Post, Paid',
                description: strings.instagram_insights_paid_impressions_per_post_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                summable: false
            },
            reach: {
                name: getValueByDimension('story', 'Frame Reach', 'Reach'),
                collection: metricEnums.collection.REACH,
                description: getValueByDimension('post', strings.instagram_insights_post_reach_description, strings.instagram_insights_story_reach_description),
                type: metricEnums.dataType.TOTAL,
                summable: false
            },
            organic_reach: {
                name: 'Reach, Organic',
                collection: metricEnums.collection.REACH,
                description: strings.instagram_insights_post_organic_reach_description,
                summable: false
            },
            organic_reach_rate: {
                name: 'Post Reach Rate by Follower, Organic',
                collection: metricEnums.collection.REACH,
                description: strings.instagram_insights_post_organic_reach_rate_description,
                metricType: metricEnums.metricType.AVERAGE,
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            paid_reach_rate: {
                name: 'Post Reach Rate by Follower, Paid',
                collection: metricEnums.collection.REACH,
                description: strings.instagram_insights_post_paid_reach_rate_description,
                metricType: metricEnums.metricType.AVERAGE,
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            paid_reach: {
                name: 'Reach, Paid',
                collection: metricEnums.collection.REACH,
                description: strings.instagram_insights_post_paid_reach_description,
                summable: false
            },
            replies: {
                name: 'Replies',
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                description: getValueByDimension('story', strings.instagram_insights_story_replies_description, strings.instagram_insights_storyday_replies_description)
            },
            swipes_forward: {
                name: 'Swipes Forward',
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                description: function (data, metric) {
                    if (metricFn.hasDimension(metric, 'storyDay')) {
                        return strings.instagram_insights_storyday_swipes_forward_description;
                    } else if (metricFn.hasDimension(metric, 'story') || metric.objectType === 'story') {
                        return strings.instagram_insights_story_swipes_forward_description;
                    } else {
                        return strings.instagram_insights_swipes_forward_description;
                    }
                },
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                type: metricEnums.dataType.TOTAL,
                enoughDataKey: 'stories'
            },
            swipes_forward_per_story: {
                name: 'Swipes Forward / Frame',
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                description: strings.instagram_insights_swipes_forward_per_story_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                type: metricEnums.dataType.AVERAGE,
                enoughDataKey: 'stories',
                summable: false
            },
            taps_forward: {
                name: 'Taps Forward',
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                description: function (data, metric) {
                    if (metricFn.hasDimension(metric, 'storyDay')) {
                        return strings.instagram_insights_storyday_taps_forward_description;
                    } else if (metricFn.hasDimension(metric, 'story') || metric.objectType === 'story') {
                        return strings.instagram_insights_story_taps_forward_description;
                    } else {
                        return strings.instagram_insights_taps_forward_description;
                    }
                },
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                type: metricEnums.dataType.TOTAL,
                enoughDataKey: 'stories'
            },
            taps_forward_per_story: {
                name: 'Taps Forward / Frame',
                description: strings.instagram_insights_taps_forward_per_story_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories',
                summable: false
            },
            taps_forward_rate: {
                name: 'Taps Forward Rate by Impression',
                description: strings.instagram_insights_story_taps_forward_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            average_taps_forward_rate: {
                name: 'Taps Forward Rate by Impression',
                description: strings.instagram_insights_average_taps_forward_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricType: metricEnums.metricType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories'
            },
            taps_back: {
                name: 'Taps Backward',
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                description: function (data, metric) {
                    if (metricFn.hasDimension(metric, 'storyDay')) {
                        return strings.instagram_insights_storyday_taps_back_description;
                    } else if (metricFn.hasDimension(metric, 'story') || metric.objectType === 'story') {
                        return strings.instagram_insights_story_taps_back_description;
                    } else {
                        return strings.instagram_insights_taps_back_description;
                    }
                },
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                type: metricEnums.dataType.TOTAL,
                enoughDataKey: 'stories'
            },
            taps_back_per_story: {
                name: 'Taps Backward / Frame',
                description: strings.instagram_insights_taps_back_per_story_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories',
                summable: false
            },
            average_taps_back_rate: {
                name: 'Taps Backward Rate by Impression',
                description: strings.instagram_insights_average_taps_back_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories',
                summable: false
            },
            completion_rate: {
                name: 'Frame Completion Rate by Impression',
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                description: strings.instagram_insights_story_completion_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                enoughDataKey: 'stories'
            },
            reach_rate: {
                name: getValueByDimension('story', 'Frame Reach Rate by Follower', 'Post Reach Rate'),
                description: getValueByDimension('post', strings.instagram_insights_post_reach_rate_description, strings.instagram_insights_story_reach_rate_description),
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories'
            },
            reach_per_post: {
                name: 'Reach / Post',
                type: metricEnums.dataType.NUMERIC,
                description: strings.instagram_insights_reach_per_post_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories',
                summable: false
            },
            organic_reach_per_post: {
                name: 'Reach / Post, Organic',
                type: metricEnums.dataType.TOTAL,
                description: strings.instagram_insights_organic_reach_per_post_description,
                collection: metricEnums.collection.REACH,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                enoughDataKey: 'stories',
                summable: false
            },
            paid_reach_per_post: {
                name: 'Reach / Post, Paid',
                type: metricEnums.dataType.TOTAL,
                description: strings.instagram_insights_paid_reach_per_post_description,
                collection: metricEnums.collection.REACH,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                enoughDataKey: 'stories',
                summable: false
            },
            reach_rate_per_post: {
                name: 'Reach Rate / Post',
                description: strings.instagram_insights_reach_rate_per_post_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories'
            },
            organic_reach_rate_per_post: {
                name: 'Post Reach Rate by Follower, Organic',
                description: strings.instagram_insights_organic_reach_rate_per_post_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.REACH,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                enoughDataKey: 'stories'
            },
            paid_reach_rate_per_post: {
                name: 'Post Reach Rate by Follower, Paid',
                description: strings.instagram_insights_paid_reach_rate_per_post_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.REACH,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                enoughDataKey: 'stories'
            },
            average_reach_rate: {
                name: 'Frame Reach Rate by Follower',
                description: strings.instagram_insights_average_reach_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'stories'
            },
            engagement_rate_by_reach: {
                name: 'Engagement Rate',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ENGAGEMENT,
                description: strings.instagram_insights_engagement_rate_by_reach_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            organic_engagement_rate_by_reach: {
                name: 'Engagement Rate by Reach, Organic',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: getValueByDimension('post', strings.instagram_insights_post_organic_engagement_rate_by_reach_description, strings.instagram_insights_organic_engagement_rate_by_reach_description),
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_engagement_rate_by_reach: {
                name: 'Engagement Rate by Reach, Paid',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: getValueByDimension('post', strings.instagram_insights_post_paid_engagement_rate_by_reach_description, strings.instagram_insights_paid_engagement_rate_by_reach_description),
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },

            // DEPRECATED METRICS
            engagement_rate_per_post: {
                name: 'Engagement Rate',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                description: strings.instagram_insights_engagement_rate_by_reach_description
            },
            organic_engagement_rate_per_post: {
                name: 'Engagement Rate by Reach, Organic',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                description: strings.instagram_insights_organic_engagement_rate_by_reach_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_engagement_rate_per_post: {
                name: 'Engagement Rate by Reach, Paid',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                description: strings.instagram_insights_paid_engagement_rate_by_reach_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            // END DEPRECATED METRICS

            order_details: {
                name: 'Frame Order',
                description: strings.instagram_insights_story_order_details_description,
                type: metricEnums.dataType.STRING,
                csvFormat: function (data) {
                    const details = (_.isArray(data) ? _.last(data) : data);
                    return details.idx + 1;
                },
                cellView: function () {
                    return {
                        tagName: 'td',
                        className: 'metric-table-cell',
                        render: function (metric, data) {
                            const orderDetails = _.last(data);
                            return [orderDetails.idx + 1, 'of', orderDetails.total].join(' ');
                        }
                    };
                },
                sort: function () {
                    return function (valueA, valueB, sortOrder) {
                        return sort.default(valueA.idx, valueB.idx, sortOrder);
                    };
                }
            },
            media_type: {
                name: getValueByDimension('post', 'Post Type', 'Story Type'),
                description: getValueByDimension('post', strings.instagram_insights_post_media_type_description, strings.instagram_insights_story_media_type_description),
                type: metricEnums.dataType.STRING
            },
            likes: {
                name: 'Likes',
                description: getValueByDimension('post', strings.instagram_insights_post_likes_description, strings.instagram_insights_likes_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            organic_likes: {
                name: 'Likes, Organic',
                modalName: 'Likes',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_likes_description, strings.instagram_insights_organic_likes_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_likes: {
                name: 'Likes, Paid',
                modalName: 'Likes',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_likes_description, strings.instagram_insights_paid_likes_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            likes_per_post: {
                name: 'Likes / Post',
                description: getValueByDimension('post', strings.instagram_insights_post_likes_per_post_description, strings.instagram_insights_likes_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            organic_likes_per_post: {
                name: 'Likes / Post, Organic',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_likes_per_post_description, strings.instagram_insights_organic_likes_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            paid_likes_per_post: {
                name: 'Likes / Post, Paid',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_likes_per_post_description, strings.instagram_insights_paid_likes_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            average_likes_per_post: {
                name: 'Likes / Post',
                description: strings.instagram_insights_post_likes_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            comments: {
                name: 'Comments',
                description: getValueByDimension('post', strings.instagram_insights_post_comments_description, strings.instagram_insights_comments_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            organic_comments: {
                name: 'Comments, Organic',
                modalName: 'Comments',
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                description: getValueByDimension('post', strings.instagram_insights_post_organic_comments_description, strings.instagram_insights_organic_comments_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            paid_comments: {
                name: 'Comments, Paid',
                modalName: 'Comments',
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                description: getValueByDimension('post', strings.instagram_insights_post_paid_comments_description, strings.instagram_insights_paid_comments_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            comments_per_post: {
                name: 'Comments / Post',
                description: getValueByDimension('post', strings.instagram_insights_post_comments_per_post_description, strings.instagram_insights_comments_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            organic_comments_per_post: {
                name: 'Comments / Post, Organic',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_comments_per_post_description, strings.instagram_insights_organic_comments_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            paid_comments_per_post: {
                name: 'Comments / Post, Paid',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_comments_per_post_description, strings.instagram_insights_paid_comments_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            average_comments_per_post: {
                name: 'Comments / Post',
                description: strings.instagram_insights_post_comments_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            saves: {
                name: 'Saves',
                description: getValueByDimension('post', strings.instagram_insights_post_saves_description, strings.instagram_insights_saves_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            organic_saves: {
                name: 'Saves, Organic',
                modalName: 'Saves',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_saves_description, strings.instagram_insights_organic_saves_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_saves: {
                name: 'Saves, Paid',
                modalName: 'Saves',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_saves_description, strings.instagram_insights_paid_saves_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            saves_per_post: {
                name: 'Saves / Post',
                description: getValueByDimension('post', strings.instagram_insights_post_saves_per_post_description, strings.instagram_insights_saves_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            organic_saves_per_post: {
                name: 'Saves / Post, Organic',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_saves_per_post_description, strings.instagram_insights_organic_saves_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            paid_saves_per_post: {
                name: 'Saves / Post, Paid',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_saves_per_post_description, strings.instagram_insights_paid_saves_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            shares: {
                name: 'Shares',
                description: function (data, metric) {
                    if (metricFn.hasDimension(metric, 'storyDay')) {
                        return strings.instagram_insights_storyday_shares_description;
                    } else if (metricFn.hasDimension(metric, 'story') || metric.objectType === 'story') {
                        return strings.instagram_insights_story_shares_description;
                    } else if (metricFn.hasDimension(metric, 'post')) {
                        return strings.instagram_insights_post_shares_description;
                    } else {
                        return strings.instagram_insights_shares_description;
                    }
                },
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: function (data, metric) {
                    return ((metricFn.hasDimension(metric, 'storyDay') || metricFn.hasDimension(metric, 'story') || metric.objectType === 'story') ? metricEnums.collection.STORY_ENGAGEMENTS : metricEnums.collection.ENGAGEMENT_DETAILS);
                }
            },
            story_shares: {
                name: 'Story Shares',
                description: strings.instagram_insights_story_shares_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS
            },
            shares_per_story: {
                name: 'Shares / Frame',
                description: strings.instagram_insights_shares_per_story_description,
                type: metricEnums.dataType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.STORY_ENGAGEMENTS,
                enoughDataKey: 'stories',
                summable: false
            },
            organic_shares: {
                name: 'Shares, Organic',
                modalName: 'Shares',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_shares_description, strings.instagram_insights_organic_shares_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_shares: {
                name: 'Shares, Paid',
                modalName: 'Shares',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_shares_description, strings.instagram_insights_paid_shares_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            shares_per_post: {
                name: 'Shares / Post',
                description: getValueByDimension('post', strings.instagram_insights_post_shares_per_post_description, strings.instagram_insights_shares_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            organic_shares_per_post: {
                name: 'Shares / Post, Organic',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_shares_per_post_description, strings.instagram_insights_organic_shares_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            paid_shares_per_post: {
                name: 'Shares / Post, Paid',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_shares_per_post_description, strings.instagram_insights_paid_shares_per_post_description),
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            paid_link_clicks: {
                name: 'Clicks, Paid',
                modalName: 'Clicks',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_link_clicks_description, strings.instagram_insights_paid_link_clicks_description),
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            video_views: {
                name: 'Initial Plays',
                type: metricEnums.dataType.TOTAL,
                description: getValueByDimension('post', strings.instagram_insights_post_video_views_description, strings.instagram_insights_video_views_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            organic_video_views: {
                name: 'Initial Plays, Organic',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_video_views_description, strings.instagram_insights_organic_video_views_description),
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_video_views: {
                name: 'Initial Plays, Paid',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_video_views_description, strings.instagram_insights_paid_video_views_description),
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            ig_reels_aggregated_all_plays_count: {
                name: 'Total Plays, Organic [DEPRECATED]',
                description: strings.instagram_insights_ig_reels_aggregated_all_plays_count_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            ig_reels_total_plays_excludes_paid_replays: {
                name: 'Total Plays, Excludes Paid Replays [DEPRECATED]',
                description: strings.ig_reels_total_plays_excludes_paid_replays_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            video_views_including_carousels: {
                name: 'Video Views (with Carousels)',
                type: metricEnums.dataType.TOTAL,
                description: strings.instagram_insights_video_views_including_carousels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            organic_video_views_including_carousels: {
                name: 'Video Views (with Carousels), Organic',
                description: strings.instagram_insights_organic_video_views_including_carousels_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_video_views_including_carousels: {
                name: 'Video Views (with Carousels), Paid',
                description: strings.instagram_insights_paid_video_views_including_carousels_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            video_views_per_post: {
                name: 'Video Views / Post',
                type: metricEnums.dataType.TOTAL,
                description: strings.instagram_insights_video_view_per_post_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            organic_video_views_per_post: {
                name: 'Video Views / Post, Organic',
                type: metricEnums.dataType.TOTAL,
                description: strings.instagram_insights_organic_video_view_per_post_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            paid_video_views_per_post: {
                name: 'Video Views / Post, Paid',
                type: metricEnums.dataType.TOTAL,
                description: strings.instagram_insights_paid_video_view_per_post_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            total_carousel_children: {
                name: 'Carousel Photo/Video Posts',
                description: strings.instagram_insights_post_total_carousel_children_description,
                type: metricEnums.dataType.TOTAL
            },
            num_photo_children: {
                name: 'Carousel Photo Posts',
                description: strings.instagram_insights_post_num_photo_children_description,
                type: metricEnums.dataType.TOTAL
            },
            num_video_children: {
                name: 'Carousel Video Posts',
                description: strings.instagram_insights_post_num_video_children_description,
                type: metricEnums.dataType.TOTAL
            },
            follows: {
                name: 'Follows, Organic',
                description: strings.instagram_insights_post_follows_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_visits: {
                name: 'Profile Views, Organic',
                description: strings.instagram_insights_post_profile_views_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_activity_total: {
                name: 'Profile Interactions, Organic',
                description: strings.instagram_insights_post_profile_interactions_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_activity_bio_link_clicked: {
                name: 'Profile Bio Link Clicks, Organic',
                description: strings.instagram_insights_post_profile_bio_link_clicks_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_activity_not_bio_link_clicked: {
                name: 'Profile Other Interactions, Organic',
                description: strings.instagram_insights_post_profile_other_interactions_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            story_follows: {
                name: 'Story Follows',
                description: strings.instagram_insights_post_follows_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            story_profile_visits: {
                name: 'Story Profile Views',
                description: strings.instagram_insights_post_profile_views_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            story_profile_activity_total: {
                name: 'Story Profile Interactions',
                description: strings.instagram_insights_post_profile_interactions_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            story_profile_activity_bio_link_clicked: {
                name: 'Story Profile Bio Link Clicks',
                description: strings.instagram_insights_post_profile_bio_link_clicks_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            story_profile_activity_not_bio_link_clicked: {
                name: 'Story Profile Other Interactions',
                description: strings.instagram_insights_post_profile_other_interactions_organic_description,
                type: metricEnums.dataType.TOTAL,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            follows_per_story: {
                name: 'Follows / Frame',
                description: strings.instagram_insights_follows_per_story_description,
                type: metricEnums.dataType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_visits_per_story: {
                name: 'Profile Views / Frame',
                description: strings.instagram_insights_profile_views_per_story_description,
                type: metricEnums.dataType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_activity_total_per_story: {
                name: 'Profile Interactions / Frame',
                description: strings.instagram_insights_profile_interactions_per_story_description,
                type: metricEnums.dataType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_activity_bio_link_clicked_per_story: {
                name: 'Profile Bio Link Clicks / Frame',
                description: strings.instagram_insights_profile_bio_link_clicks_per_story_description,
                type: metricEnums.dataType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_activity_not_bio_link_clicked_per_story: {
                name: 'Profile Other Interactions / Frame',
                description: strings.instagram_insights_profile_other_interactions_per_story_description,
                type: metricEnums.dataType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            pct_of_story_days: {
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            total_impressions: {
                name: 'Total Impressions',
                description: strings.instagram_insights_total_impressions_description,
                type: metricEnums.dataType.TOTAL
            },
            organic_total_impressions: {
                name: 'Impressions, Organic',
                description: strings.instagram_insights_organic_total_impressions_description,
                type: metricEnums.dataType.TOTAL
            },
            reach_per_story: {
                name: 'Reach / Frame',
                description: getValueByDimension('storyDay', strings.instagram_insights_storyday_reach_per_story_aggregate_description, strings.instagram_insights_reach_per_story_description),
                metricType: metricEnums.metricType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                summable: false
            },
            view_frequency: {
                name: 'View Frequency',
                description: strings.instagram_insights_view_frequency_description,
                metricType: metricEnums.metricType.AVERAGE
            },
            video_view_rate: {
                name: 'Video View Rate by Impression',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                description: getValueByDimension('post', strings.instagram_insights_post_video_view_rate_description, strings.instagram_insights_video_view_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            organic_video_view_rate: {
                name: 'Video View Rate by Impression, Organic',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                description: getValueByDimension('post', strings.instagram_insights_organic_video_view_rate_description, strings.instagram_insights_organic_video_view_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            paid_video_view_rate: {
                name: 'Video View Rate by Impression, Paid',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                description: getValueByDimension('post', strings.instagram_insights_paid_video_view_rate_description, strings.instagram_insights_paid_video_view_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS
            },
            video_views_per_user: {
                name: 'Video Views Per User',
                type: metricEnums.dataType.AVERAGE,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                description: strings.instagram_insights_video_views_per_user_description
            },
            organic_video_views_per_user: {
                name: 'Video Views per User, Organic',
                type: metricEnums.dataType.AVERAGE,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                description: strings.instagram_insights_organic_video_views_per_user_description
            },
            paid_video_views_per_user: {
                name: 'Video Views per User, Paid',
                type: metricEnums.dataType.AVERAGE,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                description: strings.instagram_insights_paid_video_views_per_user_description
            },
            boosted_post_total_spend: {
                name: 'Total Spend',
                type: metricEnums.dataType.NUMERIC
            },
            page_impressions: {
                name: 'Presence Impressions',
                description: strings.instagram_insights_page_impressions_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'statistics'
            },
            page_reach_per_day: {
                name: 'Presence Reach / Day',
                description: strings.instagram_insights_page_reach_per_day_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH,
                enoughDataKey: 'statistics',
                summable: false
            },
            page_impressions_per_day: {
                name: 'Presence Impressions / Day',
                description: strings.instagram_insights_page_impressions_per_day_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'statistics'
            },
            page_accounts_engaged_per_day: {
                name: 'Presence Accounts Engaged / Day',
                description: strings.instagram_insights_page_accounts_engaged_per_day_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_comments: {
                name: 'Presence Comments',
                description: strings.instagram_insights_page_comments_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_comments_from_ads: {
                name: 'Presence Comments, Ads',
                description: strings.instagram_insights_page_comments_from_ads_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_comments_from_carousels: {
                name: 'Presence Comments, Carousels',
                description: strings.instagram_insights_page_comments_from_carousels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_comments_from_posts: {
                name: 'Presence Comments, Posts',
                description: strings.instagram_insights_page_comments_from_posts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_comments_from_reels: {
                name: 'Presence Comments, Reels',
                description: strings.instagram_insights_page_comments_from_reels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_interactions: {
                name: 'Presence Interactions',
                description: strings.instagram_insights_page_interactions_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_likes: {
                name: 'Presence Likes',
                description: strings.instagram_insights_page_likes_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_likes_from_ads: {
                name: 'Presence Likes, Ads',
                description: strings.instagram_insights_page_likes_from_ads_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_likes_from_carousels: {
                name: 'Presence Likes, Carousels',
                description: strings.instagram_insights_page_likes_from_carousels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_likes_from_posts: {
                name: 'Presence Likes, Posts',
                description: strings.instagram_insights_page_likes_from_posts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_likes_from_reels: {
                name: 'Presence Likes, Reels',
                description: strings.instagram_insights_page_likes_from_reels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_reach_per_day_followers: {
                name: 'Presence Reach / Day, Followers',
                description: strings.instagram_insights_page_reach_per_day_followers_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH
            },
            page_reach_per_day_non_followers: {
                name: 'Presence Reach / Day, Non-Followers',
                description: strings.instagram_insights_page_reach_per_day_non_followers_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH
            },
            page_reach_per_day_from_ads: {
                name: 'Presence Reach / Day, Ads',
                description: strings.instagram_insights_page_reach_per_day_from_ads_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH
            },
            page_reach_per_day_from_carousels: {
                name: 'Presence Reach / Day, Carousels',
                description: strings.instagram_insights_page_reach_per_day_from_carousels_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH
            },
            page_reach_per_day_from_posts: {
                name: 'Presence Reach / Day, Posts',
                description: strings.instagram_insights_page_reach_per_day_from_posts_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH
            },
            page_reach_per_day_from_reels: {
                name: 'Presence Reach / Day, Reels',
                description: strings.instagram_insights_page_reach_per_day_from_reels_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH
            },
            page_reach_per_day_from_stories: {
                name: 'Presence Reach / Day, Stories',
                description: strings.instagram_insights_page_reach_per_day_from_stories_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.REACH
            },
            page_saves: {
                name: 'Presence Saves',
                description: strings.instagram_insights_page_saves_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_saves_from_ads: {
                name: 'Presence Saves, Ads',
                description: strings.instagram_insights_page_saves_from_ads_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_saves_from_carousels: {
                name: 'Presence Saves, Carousels',
                description: strings.instagram_insights_page_saves_from_carousels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_saves_from_posts: {
                name: 'Presence Saves, Posts',
                description: strings.instagram_insights_page_saves_from_posts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_saves_from_reels: {
                name: 'Presence Saves, Reels',
                description: strings.instagram_insights_page_saves_from_reels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_shares: {
                name: 'Presence Shares',
                description: strings.instagram_insights_page_shares_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_shares_from_ads: {
                name: 'Presence Shares, Ads',
                description: strings.instagram_insights_page_shares_from_ads_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_shares_from_carousels: {
                name: 'Presence Shares, Carousels',
                description: strings.instagram_insights_page_shares_from_carousels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_shares_from_posts: {
                name: 'Presence Shares, Posts',
                description: strings.instagram_insights_page_shares_from_posts_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_shares_from_reels: {
                name: 'Presence Shares, Reels',
                description: strings.instagram_insights_page_shares_from_reels_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_shares_from_stories: {
                name: 'Presence Shares, Stories',
                description: strings.instagram_insights_page_shares_from_stories_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            page_story_replies: {
                name: 'Presence Story Replies',
                description: strings.instagram_insights_page_story_replies_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            profile_links_taps: {
                name: 'Presence Link Taps',
                description: strings.instagram_insights_profile_links_taps_description,
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.PRESENCE_INTERACTIONS
            },
            social_engagement_total: {
                name: 'Social Engagement Total',
                description: getValueByDimension('post', strings.instagram_insights_post_social_engagement_total_description, strings.instagram_insights_social_engagement_total_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            organic_social_engagement_total: {
                name: 'Social Engagement Total, Organic',
                description: getValueByDimension('post', strings.instagram_insights_post_organic_social_engagement_total_description, strings.instagram_insights_organic_social_engagement_total_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            paid_social_engagement_total: {
                name: 'Social Engagement Total, Paid',
                description: getValueByDimension('post', strings.instagram_insights_post_paid_social_engagement_total_description, strings.instagram_insights_paid_social_engagement_total_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            social_engagement_rate_by_impression: {
                name: 'Social Engagement Rate by Impression',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: getValueByDimension('post', strings.instagram_insights_post_social_engagement_rate_by_impression_description, strings.instagram_insights_social_engagement_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            organic_social_engagement_rate_by_impression: {
                name: 'Social Engagement Rate by Impression, Organic',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: getValueByDimension('post', strings.instagram_insights_post_organic_social_engagement_rate_by_impression_description, strings.instagram_insights_organic_social_engagement_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            paid_social_engagement_rate_by_impression: {
                name: 'Social Engagement Rate by Impression, Paid',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: getValueByDimension('post', strings.instagram_insights_post_paid_social_engagement_rate_by_impression_description, strings.instagram_insights_paid_social_engagement_rate_by_impression_description),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            // Name inverted for consistency with Facebook metrics.
            social_engagement_rate_by_reach_organic: {
                name: 'Social Engagement Rate by Reach, Organic',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: getValueByDimension('post', strings.instagram_insights_post_social_engagement_rate_by_reach_organic_description, strings.instagram_insights_social_engagement_rate_by_reach_description_organic),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            },
            // Name inverted for consistency with Facebook metrics.
            social_engagement_rate_by_reach_paid: {
                name: 'Social Engagement Rate by Reach, Paid',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: getValueByDimension('post', strings.instagram_insights_post_social_engagement_rate_by_reach_paid_description, strings.instagram_insights_social_engagement_rate_by_reach_description_paid),
                source: metricEnums.sources.INSTAGRAM_INSIGHTS,
                collection: metricEnums.collection.ENGAGEMENT
            }
        };
    }

})();
